export default __webpack_public_path__ + "static/media/404.72d84482.svg";